module.exports = __webpack_public_path__ + "static/media/rmICon2.9db4c0f6.png";